/* eslint-disable @angular-eslint/directive-selector */
import {
    AfterViewInit,
    Directive,
    ElementRef
} from '@angular/core';

@Directive({
    selector: 'p-calendar'
})
export class GlobalCalendarTooltipDirective implements AfterViewInit {

    constructor(private el: ElementRef) { }

    ngAfterViewInit() {
        const button = this.el.nativeElement.querySelector('.p-datepicker-trigger');
        if (button) {
            // button.setAttribute('pTooltip', 'Seleccionar fecha');
            // button.setAttribute('tooltipPosition', 'top');
            button.setAttribute('title', 'Seleccionar fecha');
        }
    }
}
